interface FormattedToken {
  text: string;
  color?: string;
}

export const formatQuery = (query: string): FormattedToken[] => {
  const tokens: FormattedToken[] = [];
  let current = '';

  for (let i = 0; i < query.length; i += 1) {
    const char = query[i];

    if (
      char === ' ' ||
      char === ',' ||
      (char === '\n' && i + 1 !== query.length)
    ) {
      if (current) {
        tokens.push({ text: current });
        current = '';
      }
      tokens.push({ text: char, color: 'purple' });
      continue;
    }

    const next = query[i + 1];
    const isEnd = next === ' ' || next === undefined || next === '\n';
    const isLastComma = query[i - current.length] === ',';
    current += char;

    if (
      current === 'AND' &&
      next === ' ' &&
      !isLastComma &&
      query[i + 2] === 'N' &&
      query[i + 3] === 'O' &&
      query[i + 4] === 'T' &&
      (query[i + 5] === ' ' ||
        query[i + 5] === '\n' ||
        query[i + 6] === undefined)
    ) {
      tokens.push({ text: 'AND NOT', color: 'crimson' });
      i += 4;
      current = '';
    } else if (
      current === "NOT" &&
      next === ' ' &&
      !isLastComma &&
      isEnd
      ) {
      tokens.push({
        text: 'NOT',
        color: 'crimson',
      });
      current = '';
    } else if (current === 'AND' && !isLastComma && isEnd) {
      tokens.push({ text: 'AND', color: 'forestgreen' });
      current = '';
    } else if (current === 'OR' && !isLastComma && isEnd) {
      tokens.push({ text: 'OR', color: 'orange' });
      current = '';
    } else if (/^(NEAR|ONEAR)\/\d*$/.test(current) && !isLastComma && isEnd) {
      tokens.push({ text: current, color: '#8825EB' });
      current = '';
    } else if (current === 'NEAR' && !isLastComma && isEnd) {
      tokens.push({ text: 'NEAR', color: '#8825EB' });
      current = '';
    } else if (current === 'ONEAR' && !isLastComma && isEnd) {
      tokens.push({ text: 'ONEAR', color: '#8825EB' });
      current = '';
    } else if (isEnd && current) {
      tokens.push({ text: current });
      current = '';
    }
  }

  if (current) {
    tokens.push({ text: current });
  }

  return tokens;
};